// extracted by mini-css-extract-plugin
var _1 = "Nkv0g";
export { _1 as "base" }
